export default function Marquee({ items }) {
  const doubled = [...items, ...items, ...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-y5-line py-5 bg-y5-ink select-none">
      <div className="flex whitespace-nowrap animate-marquee items-center">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-6 text-y5-muted">
            <span className="text-sm uppercase tracking-[0.25em]">{item}</span>
            <span className="text-y5-yellow/60 text-xs">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
